var _defs, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 215",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gMain",
    x1: 18,
    y1: 190,
    x2: 182,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#7C3AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A855F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gArc",
    x1: 18,
    y1: 92,
    x2: 182,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#9333EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EC4899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gHead",
    cx: "38%",
    cy: "32%",
    r: "68%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCD34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#F97316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EF4444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gNCyan",
    cx: "38%",
    cy: "32%",
    r: "68%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#67E8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0891B2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gNBlue",
    cx: "38%",
    cy: "32%",
    r: "68%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#93C5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1D4ED8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gNPurple",
    cx: "38%",
    cy: "32%",
    r: "68%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C4B5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6D28D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gNPink",
    cx: "38%",
    cy: "32%",
    r: "68%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBCFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DB2777"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160,122 A68,68 0 1,0 40,122",
    stroke: "url(#gArc)",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 90,
    x2: 100,
    y2: 22,
    stroke: "url(#gMain)",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 90,
    x2: 140,
    y2: 35,
    stroke: "url(#gMain)",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 90,
    x2: 162,
    y2: 61,
    stroke: "url(#gMain)",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 90,
    x2: 168,
    y2: 90,
    stroke: "url(#gMain)",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 90,
    x2: 60,
    y2: 35,
    stroke: "url(#gMain)",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 90,
    x2: 38,
    y2: 61,
    stroke: "url(#gMain)",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 90,
    x2: 32,
    y2: 90,
    stroke: "url(#gMain)",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90,104 Q65,116 42,126",
    stroke: "url(#gMain)",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110,104 Q135,116 158,126",
    stroke: "url(#gMain)",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "     M 42,128     Q 38,140  50,150     Q 64,160  78,164     Q 86,180  87,205     L 100,208     L 113,205     Q 114,180 122,164     Q 136,160 150,150     Q 162,140 158,128     Q 148,124 140,128     Q 128,140 118,152     Q 112,160 100,162     Q  88,160  82,152     Q  72,140  60,128     Q  52,124  42,128     Z",
    fill: "url(#gMain)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 22,
    r: 8.5,
    fill: "url(#gNBlue)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 35,
    r: 7.5,
    fill: "url(#gNBlue)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 61,
    r: 7,
    fill: "url(#gNPurple)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 90,
    r: 7.5,
    fill: "url(#gNPurple)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 122,
    r: 7.5,
    fill: "url(#gNPink)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 122,
    r: 7.5,
    fill: "url(#gNBlue)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 90,
    r: 8.5,
    fill: "url(#gNCyan)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 61,
    r: 7,
    fill: "url(#gNCyan)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 35,
    r: 7.5,
    fill: "url(#gNBlue)"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 62,
    r: 6,
    fill: "url(#gNPurple)"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 90,
    r: 5.5,
    fill: "url(#gNPurple)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 62,
    r: 6,
    fill: "url(#gNBlue)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 90,
    r: 5.5,
    fill: "url(#gNCyan)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 90,
    r: 10.5,
    fill: "url(#gNBlue)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 78,
    r: 17,
    fill: "url(#gHead)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.42877d93b3b6baa7d6a34e97d861bc5f.svg";
export { ForwardRef as ReactComponent };